import { form } from 'stores';

import { CHANGE_DISTANCE_FORM } from '../constants';

import { changeDistanceModalStore, openChangeDistanceModalStore } from '../stores';

import { ChangeDistanceModalData } from '../types';

export const openFormModal = (data: ChangeDistanceModalData) => {
  changeDistanceModalStore.setValue(data);
  openChangeDistanceModalStore.on();
};

export const onCancel = () => {
  openChangeDistanceModalStore.off();
  form.clean(CHANGE_DISTANCE_FORM);
  changeDistanceModalStore.clear();
};
